import { render } from "./ModalIncidences.vue?vue&type=template&id=83a9a992&scoped=true"
import script from "./ModalIncidences.vue?vue&type=script&lang=js"
export * from "./ModalIncidences.vue?vue&type=script&lang=js"

import "./ModalIncidences.vue?vue&type=style&index=0&id=83a9a992&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83a9a992"]])

export default __exports__